const cards = [
  {
    title: '热门影视资源库每日更新',
    desc: '红桃视频、小蓝视频等频道每日同步最新影视资源，涵盖电影、电视剧、综艺等全品类。高清全集一网打尽，追剧不等待。',
    icon: 'ri-fire-line',
    color: 'primary',
    stat: '日均更新200+部',
  },
  {
    title: '全程高清流畅不缓冲体验',
    desc: '采用全球CDN加速与自适应码率技术，西瓜视频免费等全平台资源智能匹配最佳清晰度，保障流畅观影体验。',
    icon: 'ri-4k-line',
    color: 'accent',
    stat: '1080P/4K可选',
  },
  {
    title: '多品牌聚合一站式平台',
    desc: '茄子视频、久久视频、芒果视频等优质品牌资源一站式聚合，无需跳转多个平台，一个入口畅享全部内容。',
    icon: 'ri-stack-line',
    color: 'secondary',
    stat: '6大品牌入驻',
  },
  {
    title: '经典老片修复画质重生',
    desc: '久久视频专业修复团队采用AI画质增强技术，让经典老片重现高清光彩。怀旧佳作以全新面貌呈现。',
    icon: 'ri-magic-line',
    color: 'primary',
    stat: '4000+修复影片',
  },
  {
    title: '全终端适配随时随地观影',
    desc: '手机、平板、电脑全终端完美适配，界面简洁操作流畅。支持投屏播放与离线缓存，碎片时间也能看好片。',
    icon: 'ri-smartphone-line',
    color: 'accent',
    stat: '多设备同步观看',
  },
];

const colorMap: Record<string, { iconBg: string; iconText: string; statBg: string; statText: string }> = {
  primary: {
    iconBg: 'bg-primary-100',
    iconText: 'text-primary-600',
    statBg: 'bg-primary-50',
    statText: 'text-primary-700',
  },
  accent: {
    iconBg: 'bg-accent-100',
    iconText: 'text-accent-600',
    statBg: 'bg-accent-50',
    statText: 'text-accent-700',
  },
  secondary: {
    iconBg: 'bg-secondary-100',
    iconText: 'text-secondary-600',
    statBg: 'bg-secondary-50',
    statText: 'text-secondary-700',
  },
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            平台亮点
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            为什么选择私密视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            五大核心优势，重新定义免费在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#about"
              className="group flex flex-col p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${colorMap[card.color].iconBg}`}>
                <i className={`${card.icon} text-xl ${colorMap[card.color].iconText}`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {card.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">{card.desc}</p>
              <div className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium ${colorMap[card.color].statBg} ${colorMap[card.color].statText} w-fit`}>
                {card.stat}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}